const isAdminFilter = (isAdmin, name) => {
  const adminDepartmentSlug = 'administration';
  return isAdmin || (!isAdmin && name !== adminDepartmentSlug);
};

export { isAdminFilter };
